import { createContext, type ParentProps, useContext } from "solid-js";
import { createAiChatStore } from "./aiChatStore";

type AiChatStoreValue = ReturnType<typeof createAiChatStore>;

const AiChatContext = createContext<AiChatStoreValue>();

export function AiChatProvider(props: ParentProps) {
  const store = createAiChatStore();

  return (
    <AiChatContext.Provider value={store}>
      {props.children}
    </AiChatContext.Provider>
  );
}

export function useAiChatStore(): AiChatStoreValue {
  const store = useContext(AiChatContext);
  if (!store) {
    throw new Error("useAiChatStore must be used within AiChatProvider");
  }
  return store;
}
